import React from "react";

import svg from "../../assets/images/icons/apply.svg";

export const ApplyIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Apply"}
    />
);
